import styles from './index.module.less';
import Image from 'next/image';
const Index = ({ why }: { why: any }) => {
  return (
    <div className={styles.container}>
      <h2>{why.title}</h2>
      <div className={styles.description}>{why.desc}</div>
      <ul className={styles.list}>
        {why.cards.map((item: any, index: number) => (
          <li key={index}>
            <Image src={item.imgPath} alt={item.title} height={40} width={40}></Image>
            <h3>{item.title}</h3>
            <div className={styles.description}>{item.desc}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default Index;
